export const ClerkSignInSkin = {
    appearance: {
        variables: {
            colorBackground: '#0d1b2e',
            colorText: '#e0f0ff',
            colorPrimary: '#66b2ff',
            colorInputBackground: '#1a2a40',
            colorInputText: '#e0f0ff',
        },
    },
};

export const ClerkUserProfileSkin = {
    variables: {
        colorBackground: '#0d1b2e',
        colorText: '#e0f0ff',
        colorPrimary: '#66b2ff',
        colorInputBackground: '#1a2a40',
        colorInputText: '#e0f0ff',
    },
};

export const ClerkAccountSkin = {
    variables: {
        colorBackground: '#0d1b2e',
        colorText: '#e0f0ff',
        colorPrimary: '#66b2ff',
        colorInputBackground: '#1a2a40',
        colorInputText: '#e0f0ff',
    },
    elements: {
        userButtonPopoverActionButton: {
            color: '#e0f0ff',
        },
        userButtonPopoverActionButtonText: {
            color: '#e0f0ff',
        },

        'userButtonPopoverActionButton:hover': {
            backgroundColor: 'rgba(102, 178, 255, 0.08)',
            color: '#e0f0ff',
        },
    },
};
